import React, {Component} from "react";
import { removeCommas } from "../admin/service/excelService";

class ProcessReserveTable extends Component {

    /**
     * Handles container click events and resets row focus when users click outside editable cells.
     * @param {MouseEvent} e - Click event emitted from the table container.
     * @return {void} No return value.
     */
    handleClick = (e) => {
        const { focusRow, list_new, handleData, inputValid, handleFocusRow } = this.props;
        if (!this.node.contains(e.target)){
          console.log('click outside', e.target, focusRow);
          console.log(e.target.tagName, e.target.type);
          // If click outside, reset the focus
          if (e !== undefined && e.target!== undefined && e.target.type !== 'textarea' && e.target.tagName !== 'TR'){ // if not clicking textarea, roundup the value and reset focusRow id
            if (focusRow){
            // if (focusRow){
              console.log('reset focusRow, can format the value:', list_new[focusRow].val)
              const data = {...list_new};
              data[focusRow].val = removeCommas(data[focusRow].val);
            //   this.setState({data});
              handleData(data);
              inputValid();
              // console.log(this.state.governList_new)
            }
    
            // this.setState({focusRow:''})
            handleFocusRow('');
            // focusRow = ''
          }
          return;
        }
      }

    /**
     * Renders the reserve processing table with save actions.
     * @param {Object} props - Component props controlling data and handlers.
     * @param {Function} props.handleSubmit - Save action handler.
     * @param {Function} props.renderMethod - Function that renders table body rows.
     * @param {Array|Object} props.data - Reserve row data passed to `renderMethod`.
     * @param {Array<string>} props.columns - Displayed table column headers.
     * @return {JSX.Element} Reserve processing table layout.
     */
    render() {
        const { handleSubmit, renderMethod, data, columns } = this.props;

            return(
            
                <div className = "container" onClick = {this.handleClick}>

                    <div className="save-button">
                    <button type="button" className="btn btn-primary submit process-reserve" onClick={handleSubmit}>SAVE</button>
                    </div>
        
                    <div className = "table-container reserve-table react-bootstrap-table">
                    <form>
                        <table className="table">
                            <thead>
                            <tr>
                                {columns.map(col => {
                                   return (col=='Staff Id') ? <th key={col} ref={node => this.node = node}>{col}</th> : <th key={col}>{col}</th>
                                })}
                            </tr>
                            </thead>
                            {renderMethod(data)}
                        </table>
                    </form>
        
                    </div>
        
                    <div className="save-button">
                    <button type="button" className="btn btn-primary submit process-reserve" onClick={handleSubmit}>SAVE</button>
                    </div>
    
    
                </div>
            )
    }
}

export default ProcessReserveTable;